import React, { Component } from 'react';
import {Button, Form, Upload, message, Spin} from "antd";
import {MinusCircleOutlined, PlusOutlined, UploadOutlined} from "@ant-design/icons";
import {uploadAttachment} from "../../../requist";

class Attachment extends Component{
    constructor(props) {
        super(props);
        this.state = {
            fileList:[],
            loading:false,
        }
    }
    beforeUpload = async file => {
        if (file.size / 1024 / 1024 > 10) { // 上传的文件大于10M
            message.warning('The uploaded file size exceeds 10MB!');
            return Upload.LIST_IGNORE
        }
        this.setState({ loading: true });
        const res = await uploadAttachment(file);
        if (res.retCode === '200') {
            message.success('File uploaded successfully!');
            file.data = {s3FileName: res.data};
            this.setState({ loading: false });
            return false;
        } else {
            message.error(`${res.retMsg}`)
            this.setState({ loading: false });
            return Upload.LIST_IGNORE
        }

    };

    checkAttachment = (rule, value) => {
        return new Promise((resolve, reject) => {
            if(rule.required) {
                if (!value || value.fileList.length==0) {
                    reject(new Error("'"+rule.fullField + "' is required"))
                } else {
                    resolve(value)
                }
            }else{
                resolve()
            }

        })
    }

    UploadProps = {
        name: 'file',
        maxCount:1,
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload: this.beforeUpload
    };

    render() {
        return  <div>
            <div className="example" style={{display:this.state.loading?'block':'none'}}>
                <Spin spinning={this.state.loading} />
            </div>
            {this.props.type==2?
                <div className="spaceBox spaceHeaderBox">
                    <Form.Item
                        label={<label style={{ color: "red" }}>Attention</label>}
                        name="attention"
                    >
                        <Button danger type="text" id={'attachment-attention'}>
                            Pls compress every attachment to 10M below size for faster loading
                        </Button>
                    </Form.Item>
                    <Form.Item
                        label="Data For Dispute Processing"
                        name="processing"
                        rules={[{ required: false}]}
                    >
                        <Upload {...this.UploadProps}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        label="Confirmation from CF"
                        name="cf"
                        rules={[{ required: false }]}
                    >
                        <Upload {...this.UploadProps}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.List name="template2">
                        {(fields, { add, remove }) => (
                            <>
                                <Form.Item
                                    className={'addFormBtn'}
                                    label="Attachment"
                                >
                                    <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                    </Button>

                                </Form.Item>
                                {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                    <div>
                                        <Form.Item
                                            label="Data For Dispute Processing"
                                            name={[name,"processing"]}
                                            {...restField}
                                            fieldKey={[fieldKey, 'processing']}
                                            rules={[{ required: false }]}
                                        >
                                            <Upload {...this.UploadProps}>
                                                <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                    Upload
                                                    <MinusCircleOutlined onClick={(e) => {
                                                        remove(name)
                                                        e.stopPropagation();
                                                    }} />
                                                </Button>
                                            </Upload>
                                        </Form.Item>
                                    </div>

                                ))}
                            </>
                        )}
                    </Form.List>
                </div>:
                this.props.type==7?
                <div className="spaceBox spaceHeaderBox">
                    <Form.Item
                        label={<label style={{ color: "red" }}>Attention</label>}
                        name="attention"
                    >
                        <Button danger type="text" id={'attachment-attention'}>
                            Pls compress every attachment to 10M below size for faster loading
                        </Button>
                    </Form.Item>
                        <Form.Item
                            label="Data For Dispute Processing"
                            name="processing"
                            rules={[{ required: false}]}
                        >
                            <Upload {...this.UploadProps}>
                                <Button icon={<UploadOutlined />}>Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item
                            label="Communication with CF"
                            name="cf"
                            rules={[{ required: false}]}
                        >
                            <Upload {...this.UploadProps}>
                                <Button icon={<UploadOutlined />}>Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.List name="template2">
                            {(fields, { add, remove }) => (
                                <>
                                    <Form.Item
                                        className={'addFormBtn'}
                                        label="Attachment"
                                    >
                                        <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                        </Button>
                                        
                                    </Form.Item>
                                    {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                        <div>
                                            <Form.Item
                                                label="Data For Dispute Processing"
                                                name={[name,"processing"]}
                                                {...restField}
                                                fieldKey={[fieldKey, 'processing']}
                                                rules={[{ required: false}]}
                                            >
                                                <Upload {...this.UploadProps}>
                                                    <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                        Upload
                                                        <MinusCircleOutlined onClick={(e) => {
                                                            remove(name)
                                                            e.stopPropagation();
                                                        }} />
                                                    </Button>
                                                </Upload>
                                            </Form.Item>
                                        </div>
                                    ))}
                                </>
                            )}
                        </Form.List>
                    </div>:
                    this.props.type===8?
                        <div className="spaceBox spaceHeaderBox">
                            <Form.Item
                                label={<label style={{ color: "red" }}>Attention</label>}
                                name="attention"
                            >
                                <Button danger type="text" id={'attachment-attention'}>
                                    Pls compress every attachment to 10M below size for faster loading
                                </Button>
                            </Form.Item>
                            <Form.Item
                                label={<a style={{color:'#dc291e'}}>Lenovo Service Protocol(s)</a>}
                                name="protocol"
                                rules={[{ required: true, validator:this.checkAttachment }]}
                            >
                                <Upload {...this.UploadProps}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                            <Form.List name="template2">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Attachment"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <div>
                                                <Form.Item
                                                    label={<a style={{color:'#dc291e'}}>Lenovo Service Protocol(s)</a>}
                                                    name={[name,"protocol"]}
                                                    {...restField}
                                                    fieldKey={[fieldKey, 'protocol']}
                                                    rules={[{ required: true, validator:this.checkAttachment }]}
                                                >
                                                    <Upload {...this.UploadProps}>
                                                        <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                            Upload
                                                            <MinusCircleOutlined onClick={(e) => {
                                                                remove(name)
                                                                e.stopPropagation();
                                                            }} />
                                                        </Button>
                                                    </Upload>
                                                </Form.Item>
                                            </div>

                                        ))}
                                    </>
                                )}
                            </Form.List>
                        </div>:
                    this.props.type==4?
                    <div className="spaceBox spaceHeaderBox">
                        <Form.Item
                            label={<label style={{ color: "red" }}>Attention</label>}
                            name="attention"
                        >
                            <Button danger type="text" id={'attachment-attention'}>
                                Pls compress every attachment to 10M below size for faster loading
                            </Button>
                        </Form.Item>
                            <Form.Item
                                label="Data For Dispute Processing"
                                name="processing"
                                rules={[{ required: false}]}
                            >
                                <Upload {...this.UploadProps}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                            <Form.List name="template2">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Attachment"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <Form.Item
                                                label="Data For Dispute Processing"
                                                name={[name,"processing"]}
                                                {...restField}
                                                fieldKey={[fieldKey, 'processing']}
                                                rules={[{ required: false}]}
                                            >
                                                <Upload {...this.UploadProps}>
                                                    <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                        Upload
                                                        <MinusCircleOutlined onClick={(e) => {
                                                            remove(name)
                                                            e.stopPropagation();
                                                        }} />
                                                    </Button>
                                                </Upload>
                                            </Form.Item>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                        </div>:
                    this.props.type==5?
                    <div className="spaceBox spaceHeaderBox">
                        <Form.Item
                            label={<label style={{ color: "red" }}>Attention</label>}
                            name="attention"
                        >
                            <Button danger type="text" id={'attachment-attention'}>
                                Pls compress every attachment to 10M below size for faster loading
                            </Button>
                        </Form.Item>
                            <Form.Item
                                label="Data For Dispute Processing"
                                name="processing"
                                rules={[{ required: false }]}
                            >
                                <Upload {...this.UploadProps}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                            <Form.List name="template2">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Attachment"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <Form.Item
                                                label="Data For Dispute Processing"
                                                name={[name,"processing"]}
                                                {...restField}
                                                fieldKey={[fieldKey, 'processing']}
                                                rules={[{ required: false }]}
                                            >
                                                <Upload {...this.UploadProps}>
                                                    <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                        Upload
                                                        <MinusCircleOutlined onClick={(e) => {
                                                            remove(name)
                                                            e.stopPropagation();
                                                        }} />
                                                    </Button>
                                                </Upload>
                                            </Form.Item>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                        </div>:
                    this.props.type==6?
                <div className="spaceBox spaceHeaderBox">
                    <Form.Item
                        label={<label style={{ color: "red" }}>Attention</label>}
                        name="attention"
                    >
                        <Button danger type="text" id={'attachment-attention'}>
                            Pls compress every attachment to 10M below size for faster loading
                        </Button>
                    </Form.Item>
                    <Form.Item
                        label="SN/Label on Damage Box"
                        name="snBox"
                        rules={[{ required: true, validator:this.checkAttachment}]}
                    >
                        <Upload {...this.UploadProps}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        label="Photo of damage"
                        name="damageImage"
                        rules={[{ required: true, validator:this.checkAttachment}]}
                    >
                        <Upload {...this.UploadProps}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        label="Data For Dispute Processing"
                        name="processing"
                        rules={[{ required: false}]}
                    >
                        <Upload {...this.UploadProps}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.List name="template2">
                        {(fields, { add, remove }) => (
                            <>
                                <Form.Item
                                    className={'addFormBtn'}
                                    label="Attachment"
                                >
                                    <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                    </Button>
                                    
                                </Form.Item>
                                {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                    <div>
                                        <Form.Item
                                            label="Data For Dispute Processing"
                                            name={[name,"processing"]}
                                            {...restField}
                                            fieldKey={[fieldKey, 'processing']}
                                            rules={[{ required: false}]}
                                        >
                                            <Upload {...this.UploadProps}>
                                                <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                    Upload
                                                    <MinusCircleOutlined onClick={(e) => {
                                                        remove(name)
                                                        e.stopPropagation();
                                                    }} />
                                                </Button>
                                            </Upload>
                                        </Form.Item>
                                    </div>

                                ))}
                            </>
                        )}
                    </Form.List>
                </div>:
                <div className="spaceBox spaceHeaderBox">
                    <Form.Item
                        label={<label style={{ color: "red" }}>Attention</label>}
                        name="attention"
                    >
                        <Button danger type="text" id={'attachment-attention'}>
                            Pls compress every attachment to 10M below size for faster loading
                        </Button>
                    </Form.Item>
                            <Form.Item
                                label="Data For Dispute Processing"
                                name="processing"
                                rules={[{ required:this.props.type==1 ||this.props.type==3 || this.props.type==8 || this.props.type==11 || this.props.type==14?false:true, validator:this.checkAttachment }]}
                            >
                                <Upload {...this.UploadProps}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                            {
                                this.props.type===1?
                                    <div>
                                        <Form.Item
                                            label="SN/Label on Damage Box"
                                            name="snBox"
                                            rules={[{ required: true, validator:this.checkAttachment}]}
                                        >
                                            <Upload {...this.UploadProps}>
                                                <Button icon={<UploadOutlined />}>Upload</Button>
                                            </Upload>
                                        </Form.Item>
                                        <Form.Item
                                            label="Photo of damage"
                                            name="damageImage"
                                            rules={[{ required: true, validator:this.checkAttachment}]}
                                        >
                                            <Upload {...this.UploadProps}>
                                                <Button icon={<UploadOutlined />}>Upload</Button>
                                            </Upload>
                                        </Form.Item>
                                    </div>:''
                            }
                            <Form.List name="template2">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Attachment"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <Form.Item
                                                label="Data For Dispute Processing"
                                                name={[name,"processing"]}
                                                {...restField}
                                                fieldKey={[fieldKey, 'processing']}
                                                rules={[{ required:this.props.type==3 || this.props.type==8 || this.props.type==11 || this.props.type==14?false:true, validator:this.checkAttachment }]}
                                            >
                                                <Upload {...this.UploadProps}>
                                                    <Button className={'upload_buttom'} icon={<UploadOutlined />}>
                                                        Upload
                                                        <MinusCircleOutlined onClick={(e) => {
                                                            remove(name)
                                                            e.stopPropagation();
                                                        }} />
                                                    </Button>
                                                </Upload>
                                            </Form.Item>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                        </div>
            }

            </div>
    }
}
export default  Attachment;